import React from 'react'
import { styled, useTheme } from '@mui/material/styles'
import { useRouter } from 'next/router'
import { Box, Grid, Container, useMediaQuery } from '@mui/material'
import { Container as ContainerUI } from '@components/atoms/Container'
import AdFeedCard from '@components/organisms/Ad/AdFeedCard'
import AdFeedList from '@components/organisms/Ad/AdFeedList'
import { useGetArticleQuery, AdDeliveryDestination } from '@services/graphcms/client'
import { RelateCatalogs } from '@components/RelateCatalogs'
import { Content } from './Content'
import { RelateArticleContents } from './RelateArticleContents'

const PREFIX = 'index'

const classes = {
  root: `${PREFIX}-root`,
  containerTop: `${PREFIX}-containerTop`,
}

// TODO jss-to-styled codemod: The Fragment root was replaced by div. Change the tag if needed.
const Root = styled('div')(({ theme }) => ({
  [`& .${classes.root}`]: {
    marginTop: theme.spacing(3),
  },

  [`& .${classes.containerTop}`]: {
    marginTop: theme.spacing(1),
  },
}))

export function ArticlePage() {
  const theme = useTheme()
  const isMobileScreen = useMediaQuery(theme.breakpoints.up('xs'))
  const router = useRouter()
  const { id } = router.query

  const { data, loading } = useGetArticleQuery({
    variables: {
      id: id as string,
    },
  })

  if (!data || !data.article || loading) {
    return null
  }

  return (
    <Root>
      <Container className={classes.root} disableGutters={true}>
        <Grid container={true}>
          <Grid item xs={12} sm={8}>
            <ContainerUI>
              <Content article={data.article} />
              <RelateArticleContents article={data.article} />
              <AdFeedList destination={AdDeliveryDestination.Article1} />
              <Box marginBottom={2}>
                {(data.article.catalogFirstDepthCategoryId ||
                  data.article.catalogSecondDepthCategoryId ||
                  data.article.catalogThirdDepthCategoryId) && (
                  <RelateCatalogs
                    category={{
                      catalogFirstDepthCategoryId: data.article.catalogFirstDepthCategoryId,
                      catalogSecondDepthCategoryId: data.article.catalogSecondDepthCategoryId,
                      catalogThirdDepthCategoryId: data.article.catalogThirdDepthCategoryId,
                    }}
                  />
                )}
              </Box>
            </ContainerUI>
          </Grid>
          <Grid style={{ marginTop: isMobileScreen ? theme.spacing(1) : 0 }} item xs={12} sm={4}>
            <ContainerUI>
              <AdFeedCard destination={AdDeliveryDestination.Article2} />
            </ContainerUI>
          </Grid>
        </Grid>
      </Container>
    </Root>
  )
}
